import React from "react";
import {FormControl, Button, Dropdown, MenuItem, Navbar, Nav, NavItem} from "react-bootstrap";
import TimecardList from "../shared/timecard-list2.jsx";
import WeekPicker from "../shared/week-picker.jsx";
import moment from 'moment';
import SendSubmitTimecardReminder from "../shared/send-submit-timecard-reminder";
import StaffAutoComplete from "../shared/staff-autocomplete.jsx";

export default class SearchForm2 extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            showSubmitTimecardDialog: false,
            submitTimecardId: 0,
            peopleName: ''
        };

        this.onFieldChange = this.onFieldChange.bind(this);
        this.onStaffChange = this.onStaffChange.bind(this);     
        this.countSelectedItem = this.countSelectedItem.bind(this);
        this.inputs = {};
        this.toggleSubmitTimecardDialog = this.toggleSubmitTimecardDialog.bind(this);
        this.submitTimecardAfterSend = this.submitTimecardAfterSend.bind(this);
    }

    toggleSubmitTimecardDialog(show, timecardId, peopleName) {
        this.setState({
            showSubmitTimecardDialog: show,
            submitTimecardId: timecardId,
            peopleName: peopleName
        });
    }

    submitTimecardAfterSend(timecardId) {
        let timecardList = this.props.vm.timecardList;
        let timecard = timecardList.timecards.filter(x => x.timecardSummary.timecardId == parseInt(timecardId));

        if (timecard.length) {
            timecardList.timecards[timecardList.timecards.indexOf(timecard[0])].timecardSummary.submitReminder = true;
        }

        var patch = {
            timecardList : timecardList
        };
        this.props.onFieldChange({search: patch});
    }

    onFieldChange(fieldName, value, callback) {
        var patch = {
            [fieldName] : value
        };
        this.props.onFieldChange({search: patch}, callback);
    }

    onStaffChange(value, callback) {
        var values = value.split('_');
        var peopleId = values[0];
        var approverId = values[1];
        var approverName = values[2];
        var staffCount = 0;
        var navigationLevel = 0;

        if (values.length > 3) {
            staffCount = parseInt(values[3]);
        }
        
        var navigation = this.props.vm.navigation;
        if (values.length > 4) {
            navigationLevel = parseInt(values[4]);
            navigation = navigation.filter(x => x.level <= navigationLevel);
        }
        else if (approverId == '') {
            navigation = navigation.filter(x => x.level <= 1);
        }
        else if (approverId != '' && values.length > 3) {
            if (approverId != this.props.vm.approverId) {
                navigation.push({
                    level: navigation.length + 1,
                    approverId: approverId,
                    approverName: approverName,
                    staffCount: staffCount
                });
            }
        }
        
        var patch = {
            peopleId: peopleId,
            approverId: approverId,
            staffLabel: approverId != '' ? approverName + ' - ' + staffCount + ' Staff' : approverName,
            navigation: navigation
        }

        this.props.onFieldChange({search: patch}, callback);

        if (this.props.updateStatusCount) {
            this.props.updateStatusCount("unverified", 'countSubmittedPrevious', new Date(moment(this.props.vm.weekEndingDate).add(-7, 'days')), approverId, peopleId);
            this.props.updateStatusCount("unverified", 'countSubmittedNext', new Date(moment(this.props.vm.weekEndingDate).add(7, 'days')), approverId, peopleId);
        }
    }

    countSelectedItem() {
        try {
            let count = 0;
            let vm = this.props.vm;
            for(let i = 0; i < vm.timecardList.timecards.length; i++) {
                let tc = vm.timecardList.timecards[i].timecardSummary;                
                if (tc.isChecked && !(tc.isEdited || tc.isIncomplete)) count ++;
            }

            return count;
        } catch(e) {
            console.log(e);
            return 0;
        }
    }

    render() {  
        const self = this;
        let vm = this.props.vm;        
        if (vm != null) { 
            let totalPage = vm.timecardList.total / vm.pageSize + 
            (vm.timecardList.total % vm.pageSize > 0 ? 1 : 0);        
            let verifyTcButtonClass = "ap-fullsize ";
            let verifyTcButtonDisabled = false;
            if (this.countSelectedItem() > 0) verifyTcButtonClass += "btn-info";
            else verifyTcButtonDisabled = true;

            let navigation = null;
            if (vm.navigation.length > 1) {
                navigation = <Navbar className="ap-navbar-custom">
                    <Nav onSelect={(eventKey) => this.onStaffChange(eventKey, this.props.onSearch)}>
                        {vm.navigation.map(function(nav, idx) {
                            return (<NavItem className={idx == vm.navigation.length - 1 ? 'ap-color-darkgray-a' : 'ap-color-gray-a'} eventKey={'_' + nav.approverId + '_' + nav.approverName + '_' + nav.staffCount + '_' + nav.level} href="#">
                                {(nav.level == 1 ? nav.approverName : nav.approverName + ' - ' + nav.staffCount + ' Staff')}
                                {idx == vm.navigation.length - 1 ? '' : <span className="ap-color-darkgray-a-icon"><i className="glyphicon glyphicon-menu-right"></i></span>}
                            </NavItem>);
                        })}
                    </Nav>
                </Navbar>;
            }

            let currentWeekEndingDate = moment(vm.currentWeekEndingDate).format("MM/DD/YYYY");
            let weekEndingDate = moment(vm.weekEndingDate).format("MM/DD/YYYY");

            return(            
                <div className="container">
                    <SendSubmitTimecardReminder 
                        show={this.state.showSubmitTimecardDialog}
                        toggleDialog={this.toggleSubmitTimecardDialog}
                        afterSend={this.submitTimecardAfterSend}
                        role={this.props.role}
                        timecardId={this.state.submitTimecardId}
                        vm={this.props.vm} 
                        peopleName={this.state.peopleName}>
                    </SendSubmitTimecardReminder>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="col-md-3">Date:</div>
                                    <div className="col-md-9 ap-no-padding-right ap-view-current-week-container"><a href="#" title={currentWeekEndingDate} 
                                        onClick={(evt) => { 
                                            evt.preventDefault();
                                            if (currentWeekEndingDate != weekEndingDate) {
                                                this.onFieldChange("weekEndingDate", new Date(evt.target.title), this.props.onSearch);

                                                if (this.props.updateStatusCount) {
                                                    this.props.updateStatusCount("unverified", 'countSubmittedPrevious', new Date(moment(evt.target.title).add(-7, 'days')), vm.approverId, vm.peopleId);
                                                    this.props.updateStatusCount("unverified", 'countSubmittedNext', new Date(moment(evt.target.title).add(7, 'days')), vm.approverId, vm.peopleId);
                                                } 
                                            }
                                            return false;
                                        }} className={"ap-link-small ap-view-current-week " + (currentWeekEndingDate == weekEndingDate ? 'current-week' : '')}>View Current Week</a></div>
                                </div>
                                <div className="col-md-12">
                                    <WeekPicker id="week" vm={this.props.vm} onFieldChange={this.onFieldChange} 
                                        onSearch={this.props.onSearch} updateStatusCount={this.props.updateStatusCount}>
                                    </WeekPicker>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">Staff:</div>
                                <div className="col-md-12">
                                    <div className="ap-bootstrap-dropdown">
                                        <StaffAutoComplete
                                            id="staff" 
                                            items={vm.peopleList}
                                            defaultValue="All Direct Reports"
                                            onChange={this.onStaffChange}
                                            onSearch={this.props.onSearch}
                                            value={vm.staffLabel} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">Status:</div>
                                <div className="col-md-12">
                                    <FormControl componentClass="select" defaultValue=""
                                        onChange={(evt) => this.onFieldChange("status", evt.target.value, this.props.onSearch)}>
                                        <option key="all" value="all">All</option>
                                        <option key="Submitted" value="Submitted">Submitted</option>
                                        <option key="Saved" value="Saved">Unsubmitted</option>
                                        <option key="Approved" value="Approved">Verified</option>
                                        <option key="Processed" value="Processed">Processed</option>
                                        {/* <option key="Purge" value="Purge">Purge</option> */}
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {navigation}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">                            
                            <TimecardList vm={vm.timecardList} totalPage={totalPage} page={vm.page} onNavigate={this.props.onNavigate}                            
                                onTcItemChecked={this.props.onTcItemChecked} role={this.props.role} onStaffChange={this.onStaffChange}
                                onSearch={this.props.onSearch}
                                toggleSubmitTimecardDialog={this.toggleSubmitTimecardDialog}
                                showSubmitTimecardDialog={this.state.showSubmitTimecardDialog}
                                onSortChange={this.props.onSortChange} 
                                sortExpression={vm.sortExpression} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button className={verifyTcButtonClass} 
                                onClick={() => self.props.onVerify()}
                                disabled={verifyTcButtonDisabled}>Verify Selected Timecards</Button>
                        </div>
                    </div>                    
                </div>
                );            
        } else {
            return(
                <div className="container">
                    <div className="row">
                        
                    </div>
                </div>
                );
        }
        
    }
}